export default __webpack_public_path__ + "static/media/ava-04.37c3b659.png";